import { render, staticRenderFns } from "./OrderShipping.vue?vue&type=template&id=e323c784&"
import script from "./OrderShipping.vue?vue&type=script&lang=js&"
export * from "./OrderShipping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e323c784')) {
      api.createRecord('e323c784', component.options)
    } else {
      api.reload('e323c784', component.options)
    }
    module.hot.accept("./OrderShipping.vue?vue&type=template&id=e323c784&", function () {
      api.rerender('e323c784', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Automation/OrderShipping.vue"
export default component.exports